const ENV = process.env.REACT_APP_ENV || "development";

const API_URLS = {
  development: process.env.REACT_APP_API_URL_DEV,
  staging: process.env.REACT_APP_API_URL_STAGING,
  production: process.env.REACT_APP_API_URL_PROD,
};

const apiBaseUrl = API_URLS[ENV];

if (!apiBaseUrl) {
  throw new Error(`API base URL not configured for env: ${ENV}`);
}

export const authBypassPaths = [
  "/auth/login",
  "/auth/admin/login",
  "/auth/signup",
  "/auth/forgot-password",
  "/auth/reset-password",
  "/auth/verify-email",
  "/auth/resend-verification-code",
  "/auth/refresh-tokens",
  "/settings/maintenance",
];

export const config = {
  env: ENV,
  apiBaseUrl,
};
